// extracted by mini-css-extract-plugin
module.exports = {"location":"eventLocation_location__33brx","locationIcon":"eventLocation_locationIcon__1UkXY","locationLink":"eventLocation_locationLink__32FFQ"};